import './Footer.css'; 
import React from 'react';
import { FaHome , FaPhone , FaMailBulk, FaInstagram, FaLinkedin, FaGithub, FaCode} from "react-icons/fa";

const Footer = () => {
  return (
    <div  className='footer'>
        <div className='footer-container'>
            <div className='left'>
                <div className='location'>
                    <h5><FaHome  size={20} style={{color:'white', marginRight: '2rem'}}/>
                    South Bangalore , Karnataka,
                    India</h5>
                </div>
            
                <div className='phone'>
                <h5><FaPhone  size={20} style={{color:'white', marginRight: '2rem'}}/>
                  +91 8088351591</h5>
                </div>

                <div className='mail'>
                <h5><FaMailBulk  size={20} style={{color:'white', marginRight: '2rem'}}/>
                  bsharanya25@gmail.com</h5>
                </div>  
            </div>

            <div className='right'>
              <div className='social'>
                <p>I have a deep appreciation for technology, always drawn to the latest gadgets and I enjoy staying updated on the advancements that shape our modern world. </p>
                <p className='bold'>Connect here:</p>
                <a href="https://instagram.com/shharanyaa_?igshid=MzNlNGNkZWQ4Mg=="><h5>
                <FaInstagram  size={20} style={{color:'white', marginRight: '2rem'}}/></h5></a>
                <a href="https://github.com/bsharanya-25"><h5>
                <FaGithub  size={20} style={{color:'white', marginRight: '2rem'}}/></h5></a>
                <a href="https://www.linkedin.com/in/b-sharanya-5077b1203"><h5>
                <FaLinkedin  size={20} style={{color:'white', marginRight: '2rem'}}/></h5></a>
                <a href="https://leetcode.com/bsharanya25/"><h5>
                <FaCode size={20} style={{color:'white', marginRight: '2rem'}}/></h5></a>
              </div>
            </div>
        </div>
      </div>
  )
}

export default Footer